<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body flex justify-content-between">
        <div class="flex">
          <div>
            <input type="file" ref="uploadFileInput" @change="chooseFile"
                   accept=".csv" class="input-file pointer"/>
            <LoadingButton
              title="Загрузить заявки через файл"
              type="button"
              :loading="loading"
              :color="$constants.PRIMARY_COLOR"
              :onClick="() => uploadFile()"
              className="btn btn-outline-success btn-xs"
            />
          </div>
          <div class="ml-1">
            <input type="file" ref="uploadCheckFileInput" @change="chooseCheckFile"
                   accept=".pdf" class="input-file pointer"/>
            <LoadingButton
              title="Проверка индексов"
              type="button"
              :loading="loading"
              :color="$constants.PRIMARY_COLOR"
              :onClick="() => checkIndex()"
              className="btn btn-outline-info btn-xs"
            />
          </div>
        </div>
        <div>
          <LoadingButton
            v-if="[...errorOrders, ...solvedOrders].length"
            title="Закрыть заявки"
            type="button"
            :loading="loading"
            :color="$constants.SUCCESS_COLOR"
            :onClick="() => confirmOrders()"
            className="btn btn-outline-success btn-xs"
          />
        </div>
      </div>
    </div>

    <div class="card" v-if="checkOrders && !selectedFile">
      <div class="card-body">
        <CheckedPostOrdersList
          :pass="checkOrders.pass"
          :errors="checkOrders.errors"
        />
      </div>
    </div>

    <div class="card" v-if="solvedOrders.length || errorOrders.length">
      <div class="card-body">
        <table class="table mt-0 table-hover table-sm">
          <thead>
          <tr>
            <th>#</th>
            <th><input type="checkbox" @change="selectAll"></th>
            <th>ID</th>
            <th>Клиент</th>
            <th>Адрес</th>
            <th></th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(o,i) in [...errorOrders, ...solvedOrders]">
            <td>{{ i + 1 }}</td>
            <td>
              <input v-if='o.id' type="checkbox" v-model="selectedOrders[o.id]">
            </td>
            <template v-if="o.order">
              <td>{{ o.order.id }}</td>
              <td>
                <p>{{ o.order.client_name }}</p>
                <p>{{ o.order.phone }}</p>
              </td>
              <td>
                <p>{{ o.order.address }}</p>
                <p>{{ o.order.track_number }}</p>
              </td>
              <td>
                <p>{{ o.message }}</p>
                <p>стоимость: <strong>{{ o.order.post_sum }}</strong></p>
              </td>
              <td></td>
            </template>
            <template v-else>
              <td>{{ o.id }}</td>
              <td>{{ o.client_name }}</td>
              <td>{{ o.address }}</td>
              <td><span class="badge badge-success">Верифицирована</span></td>
              <td></td>
            </template>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";
import CheckedPostOrdersList from "@/views/orders/components/CheckedPostOrdersList.vue";

export default {
  components: {LoadingButton, CheckedPostOrdersList},
  data() {
    return {
      loading: false,
      selectedFile: null,
      selectedCheckFile: null,
      solvedOrders: [],
      errorOrders: [],
      checkOrders: null,
      selectedOrders: {},
    }
  },
  methods: {
    selectAll(e) {
      const check = e.target.checked;
      this.selectedOrders = {};
      this.solvedOrders.forEach((o) => {
        this.selectedOrders[o.id] = check;
      })
      this.selectedOrders = {...this.selectedOrders};
    },
    async confirmOrders() {
      if (!Object.values(this.selectedOrders).filter((s) => s).length) {
        toastr['warning']('Выберите заявки для закрытия');
        return;
      }
      const code = Math.floor(Math.random() * 9000 + 1000);
      const setCodePass = prompt(`Вы уверены, что взяли в работу заявки, которые требуют ручного вмешательства. Если да, то введите код ${code} и другие заявки закроются автоматически`);
      if (code !== +setCodePass) return;
      const result = await this.uploadFile(true);
      if (result) {
        this.solvedOrders = [];
        this.errorOrders = [];
      }

    },
    async checkIndex() {
      if (!this.selectedCheckFile) return;
      this.selectedOrders = {};
      this.loading = true;
      this.selectedFile = null;
      this.checkOrders = null;
      let formData = new FormData();
      formData.append('file', this.selectedCheckFile);
      const {data} = await api.post('/new/orders/checkFileIndex',
        formData, true);
      if (data.success) {
        this.checkOrders = {
          pass: data.pass ?? [],
          errors: data.errors ?? []
        };
      } else {
        toastr['warning'](data.message || 'Ошибка');
        this.loading = false;
        return false;
      }
      this.loading = false;
    },
    async uploadFile(confirm = false) {
      if (!this.selectedFile) return;
      // this.selectedOrders = {};
      this.loading = true;
      let formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('selectedOrders', Object.keys(this.selectedOrders).filter((k) => this.selectedOrders[k]));
      formData.append('confirm', +confirm);
      const {data} = await api.post('/new/orders/postByFile',
        formData, true);
      if (data.success) {
        this.solvedOrders = data.solved;
        this.errorOrders = data.errors;
      } else {
        toastr['warning'](data.message || 'Ошибка');
        this.loading = false;
        return false;
      }
      this.loading = false;
      return true;
    },
    chooseFile(e) {
      this.selectedFile = e.target.files[0];
    },
    chooseCheckFile(e) {
      this.selectedCheckFile = e.target.files[0];
    }
  }
}

</script>
